import { api } from "@/lib/api";

const BASE = process.env.REACT_APP_BACKEND_URL;
const TTL = 60000;
let cache = null;

const abs = (src) => (typeof src === "string" && src.startsWith("/api/") ? `${BASE}${src}` : src);
export const normalizeProduct = (p) => (p ? { ...p, images: (Array.isArray(p.images) ? p.images : []).map(abs) } : p);
const normalizeList = (data) => (Array.isArray(data) ? data.map(normalizeProduct) : []);

export const fetchProducts = (force = false) => {
  if (!force && cache && Date.now() - cache.at < TTL) return cache.promise;
  const promise = api.get("/products").then((r) => normalizeList(r?.data));
  cache = { at: Date.now(), promise };
  promise.catch(() => { cache = null; });
  return promise;
};

export const fetchProduct = (id) => api.get(`/products/${id}`).then((r) => normalizeProduct(r?.data));
export const fetchSold = () => api.get("/products/sold").then((r) => normalizeList(r?.data));
